import React, { useState, useEffect } from "react";
import { Grid2, CircularProgress, Button } from "@mui/material";
import companyLogo from "assets/login-logo.png";
import headerLogo from "assets/header-logo-2.jpg";
import doctorLogo from "assets/dr-logo.jpg";
import emailLogo from "assets/email.png";
import lockLogo from "assets/lockCopy@2x.png";
import { useNavigate } from "react-router-dom";
import { logout, billingLogin, providerLogin } from "apiHandler/actions/auth";
import { useUpdateUserData } from "components/customHooks/userDataContext";
import ResetPasswordModal from "components/modals/resetPassword";

const Auth = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [openReset, setOpenReset] = useState(false);
  const setUserData = useUpdateUserData();
  const navigate = useNavigate();

  useEffect(() => {
    logout();
    setUserData(null);
  }, []);

  const handleCloseResetPassword = () => {
    setOpenReset(false);
  };

  const handleOpenResetPassword = () => {
    setOpenReset(true);
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    const login_data = await Promise.all([
      billingLogin(email, password),
      providerLogin(email, password),
    ]);
    const billing_data = login_data[0];
    const provider_data = login_data[1];
    if (billing_data && provider_data) {
      const userData = {
        ...provider_data,
        billing_id_token: billing_data.id_token,
        billing_refresh_token: billing_data.refresh_token,
        billing_access_token: billing_data.access_token,
        userType: provider_data.user_details.user_role,
        loginTime: new Date(),
        email: email.toLocaleLowerCase(),
      };
      setUserData(userData);
      console.log(userData, "userData");

      if (userData.userType === "Admin") {
        navigate("/admin/dashboard");
      } else {
        navigate("/select-practice");
      }
    } else {
      alert("LOGIN FAILED");
      navigate("/login", { replace: true });
      setLoading(false);
    }
  };

  return (
    <form onSubmit={onSubmit} className="login">
      <Grid2 container>
        <Grid2 item size={{ sm: 6 }} className="login-logo-cont">
          <div className="logo">
            <img src={companyLogo} width="100%" alt="logo" />
          </div>
          <h1 className="mt-50">Healthcare Management</h1>
          <p>
            Welcome! An easy to use application that allows you to manage your
            practice billing and revenue management cycle effectively.
          </p>
          <a
            href="https://orcicare.com/providers/"
            target="_blank"
            rel="noreferrer"
          >
            <div className=" learn-more-btn">Learn more</div>
          </a>
        </Grid2>
        <Grid2 item size={{ xs: 12, sm: 6 }} className="login-right">
          <div className="right-logo">
            <img src={headerLogo} alt="Logo" />
          </div>
          <div className="text-center">
            <img src={doctorLogo} alt="Doctor Logo" height={80} />
          </div>
          <div className="text-center">
            <h1>Welcome. Let`s get started</h1>
            <p className="details">Please enter your details below</p>
          </div>
          <div className="login-form">
            <div className="login-input-group">
              <span>
                <img
                  src={emailLogo}
                  alt="logo"
                  style={{ marginBottom: "-20px" }}
                />
              </span>
              <input
                type="email"
                placeholder="E-Mail *"
                aria-label="Email"
                value={email}
                aria-describedby="basic-addon1"
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="login-input-group">
              <span>
                <img src={lockLogo} alt="logo" />
              </span>
              <input
                type="password"
                placeholder="Password *"
                aria-label="Email"
                value={password}
                aria-describedby="basic-addon1"
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <div className="text-center mt-50">
              <button type="submit" className="submit">
                {loading ? (
                  <CircularProgress size={30} style={{ color: "#fff" }} />
                ) : (
                  "Sign In"
                )}
              </button>
            </div>
            <div className="text-center mt-50 mb-50">
              <Button
                variant="text"
                sx={{ color: "gray" }}
                size="small"
                onClick={handleOpenResetPassword}
              >
                Forgot your password?
              </Button>
            </div>
            <div className="text-center">
              By creating your account you are agreeing
              <br />
              with our
              <span className="cyan-color cursor" target="_blank">
                {" "}
                Terms and Conditions
              </span>
            </div>
          </div>
        </Grid2>
      </Grid2>
      <ResetPasswordModal open={openReset} onClose={handleCloseResetPassword} />
    </form>
  );
};

export default Auth;
